export default {
    VARIANT_CHANGE: 'buy-box-variant-change',
    ADD_TO_CART: 'buy-box-add-to-cart',
};
